import { GoogleOAuthProvider } from '@react-oauth/google'
import { QueryClientProvider } from '@tanstack/react-query'
import posthog from 'posthog-js'
import React from 'react'
import ReactDOM from 'react-dom/client'
import 'shepherd.js/dist/css/shepherd.css'

import { App, queryClient } from './App'
import { SupabaseProvider } from './api/supabase'
import './global.css'
import { Toaster } from './shared/components/ui/toaster'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

if (import.meta.env.PROD) {
  posthog.init(import.meta.env.VITE_POSTHOG_API_KEY!, {
    api_host: import.meta.env.VITE_POSTHOG_API_HOST!,
    person_profiles: 'always',
    capture_pageview: 'history_change', // Proper SPA pageview tracking for React Router
    capture_exceptions: true,
  })
}

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <GoogleOAuthProvider clientId="931867979080-b6chc9bk92v66g8osfjjrjgeig7gaji5.apps.googleusercontent.com">
        <SupabaseProvider>
          <Toaster />
          <App />
        </SupabaseProvider>
      </GoogleOAuthProvider>
    </QueryClientProvider>
  </React.StrictMode>
)
